'use strict';

var $ = require('jquery');
var slider = require('../components/slider.js');
var financeCalculator = require('../utils/finance-calculator.js');
var analytics = require('../utils/analytics.js');

var classNames = {
	financeWidget: 'finance-widget',
	resultValue: 'results__item__value',
	resultLabel: 'results__item__label',
	applyLink: 'apply-link',
	inputField: 'input__field',
	inputValue: 'input__value',
	inputSlider: 'input__slider',
	inputDecrement: 'input__decrement',
	inputIncrement: 'input__increment',
	select: 'select',
	amount: 'amount',
	term: 'term',
	make: 'make',
	model: 'model',
	vrm: 'vrm',
	imageUrl: 'image-url',
	creditRating: 'credit-rating',
	clickTrack: 'click-track',
	changeTrack: 'change-track'
};

var values = {
	amount: '0',
	creditRating: '',
	term: '0',
	make: '',
	model: '',
	vrm: '',
	imageUrl: ''
};

var resultFields = {
	creditCost: null,
	monthlyRepayment: null,
	totalPayable: null,
	term: null
};

var applyUrlFormat;

var trackingLabel;
var trackingAction = 'Interaction';
var trackingCategory = 'Car Finance 247';

function setValue($field) {
	var value = parseFloat($field.val());
	var step = parseFloat($field.attr('step'));
	var min = parseFloat($field.attr('min'));
	var max = parseFloat($field.attr('max'));

	if (!$.isNumeric(value) || value < min) {
		$field.val(min);
	}
	else if (value > max) {
		$field.val(max);
	}
	else if (value > 0 && step > 0) {
		$field.val(Math.ceil(value / step) * step);
	}
}

function displayResults(results) {
	resultFields.creditCost.text(results.creditCost);
	resultFields.monthlyRepayment.text(results.monthlyRepayment);
	resultFields.totalPayable.text(results.totalPayable);
	resultFields.term.text(values.term * 12 + ' monthly repayments');
}

function updateApplyUrl($link) {
	var url = applyUrlFormat
		.replace('{Amount}', values.amount)
		.replace('{Term}', values.term * 12)
		.replace('{VRM}', values.vrm)
		.replace('{Make}', values.make)
		.replace('{Model}', values.model)
		.replace('{ImageUrl}', values.imageUrl);

	$link.attr('href', url);
}

function updateResults() {
	var results = financeCalculator.calculate(values.amount, values.term, values.creditRating);

	displayResults(results);
}

function getSliderOptions($inputField, startValue) {
	return {
		range: {
			'min': parseFloat($inputField.attr('min')),
			'max': parseFloat($inputField.attr('max')),
		},
		start: startValue,
		step: parseFloat($inputField.attr('step')),
		tooltips: false
	};
}

function initTrackingEvents() {
	if (!trackingLabel) {
		return;
	}

	$.findByBem(classNames.financeWidget, classNames.clickTrack).on('click', function () {
		analytics.trackEvent(trackingCategory, trackingAction, trackingLabel);
	});

	$.findByBem(classNames.financeWidget, classNames.changeTrack).on('change set', function () {
		analytics.trackEvent(trackingCategory, trackingAction, trackingLabel);
	});
}

function initControls($context) {
	var $amountInput = $.findByBem(classNames.financeWidget, classNames.inputField, classNames.amount, $context);
	var $amountSlider = $.findByBem(classNames.financeWidget, classNames.inputSlider, classNames.amount, $context);
	var $amountDecrement = $.findByBem(classNames.financeWidget, classNames.inputDecrement, classNames.amount, $context);
	var $amountIncrement = $.findByBem(classNames.financeWidget, classNames.inputIncrement, classNames.amount, $context);

	var $termInput = $.findByBem(classNames.financeWidget, classNames.inputField, classNames.term, $context);
	var $termValue = $.findByBem(classNames.financeWidget, classNames.inputValue, classNames.term, $context);
	var $termSlider = $.findByBem(classNames.financeWidget, classNames.inputSlider, classNames.term, $context);
	var $termDecrement = $.findByBem(classNames.financeWidget, classNames.inputDecrement, classNames.term, $context);
	var $termIncrement = $.findByBem(classNames.financeWidget, classNames.inputIncrement, classNames.term, $context);

	var $creditRatingSelect = $.findByBem(classNames.financeWidget, classNames.select, classNames.creditRating, $context);

	var $applyLink = $.findByBem(classNames.financeWidget, classNames.applyLink);

	var $container = $.findByBem(classNames.financeWidget, null, null, $context);

	values.amount = $amountInput.val();
	values.term = $termInput.val();
	values.creditRating = $creditRatingSelect.val();
	values.make = $container.data('make');
	values.model = $container.data('model');
	values.vrm = $container.data('vrm');
	values.imageUrl = $container.data('image-url');

	$amountInput.on('change.financeWidget', function () {
		setValue($(this));
		values.amount = $(this).val();
		updateResults();
		updateApplyUrl($applyLink);
	});

	$.findByBem(classNames.financeWidget, classNames.inputDecrement).on('click.financeWidget', function (e) {
		e.preventDefault();
	});

	$.findByBem(classNames.financeWidget, classNames.inputIncrement).on('click.financeWidget', function (e) {
		e.preventDefault();
	});

	var amountSliderOptions = getSliderOptions($amountInput, values.amount);
	slider.init($amountSlider, amountSliderOptions, $amountInput, null, null, $amountDecrement, $amountIncrement).on('set.financeWidget', function (value) {
		values.amount = value;
		updateResults();
		updateApplyUrl($applyLink);
	});


	var termSliderOptions = getSliderOptions($termInput, values.term);
	slider.init($termSlider, termSliderOptions, $termInput, null, null, $termDecrement, $termIncrement).on('set.financeWidget', function (value) {
		values.term = value;
		$termValue.html(values.term * 12 + ' months');
		updateResults();
		updateApplyUrl($applyLink);
	});

	$creditRatingSelect.on('change.financeWidget', function () {
		values.creditRating = $(this).val();
		updateResults();
	});

	initTrackingEvents();
}

function initDisplayFields($container) {
	resultFields.creditCost = $.findByBem(classNames.financeWidget, classNames.resultValue, 'credit-cost', $container);
	resultFields.monthlyRepayment = $.findByBem(classNames.financeWidget, classNames.resultValue, 'monthly', $container);
	resultFields.totalPayable = $.findByBem(classNames.financeWidget, classNames.resultValue, 'total-payable', $container);
	resultFields.term = $.findByBem(classNames.financeWidget, classNames.resultLabel, 'monthly');
}

module.exports = {
	init: function ($context) {
		var $container = $.findByBem(classNames.financeWidget, null, null, $context);
		if ($container.length) {
			var aprRates = JSON.parse($container.attr('data-apr'));
			var interestRates = JSON.parse($container.attr('data-interest-rate'));

			trackingLabel = $container.attr('data-tracking-label');
			applyUrlFormat = $container.attr('data-apply-url-format');

			financeCalculator.init(aprRates, interestRates);

			initControls($context);
			initDisplayFields($container);
			updateResults();
		}
	}
};